import React, { useContext } from 'react';
import { useCitySelectMenuDialog } from 'app/components/ui/Tag/hooks/useCitySelectMenuDialog';
import { LocationContext } from 'app/containers/LocationProvider';
import { analyticService } from 'global/services';
import { AbstractSelectTag } from './SelectTag';
import { getCityMetaByLocationKey } from 'app/const/location';


export function CitySelectTag() {
    const { locationKey } = useContext(LocationContext);
    const { pushCitySelectDialog } = useCitySelectMenuDialog();
    const meta = getCityMetaByLocationKey(locationKey);
    const title = meta.title;

    const togleCitySelect = () => {
        analyticService
            .push({ eventName: 'Filter_Open_City', eventAction: 'Open', eventLabel: 'City' });
        pushCitySelectDialog();
    };


    return (
        <AbstractSelectTag
            placeHolder="город"
            text={title}
            onClickHandler={togleCitySelect}
        />
    );
}
